import {ChangeDetectionStrategy, Component, HostBinding, input} from '@angular/core';

@Component({
  selector: 'homey-why-card',
  imports: [],
  templateUrl: './why-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WhyCardComponent {
  @HostBinding('class') readonly class = 'block overflow-hidden rounded-xl';
  image = input.required<string>();
  title = input.required<string>();
  description = input.required<string>();
}
